module.exports = __webpack_public_path__ + "static/media/bkg_tst.240f782b.png";